module.exports = __webpack_public_path__ + "img/feedback_great.8c2f928b.png";